import classnames from 'classnames'
import React from 'react'

import { AnonymousLearningItem } from '../../models/AnonymousLearningItem'
import LearningItemImage from '../LearningItemImage/LearningItemImage'

import styles from './LearningItemAvatar.module.scss'

type AvatarProps = { learningItem: AnonymousLearningItem } & React.ComponentPropsWithoutRef<'div'>

export default React.memo(function GroupAvatar({ learningItem, className, ...htmlProps }: AvatarProps) {
  return (
    <div className={classnames(styles.LearningItemAvatar, className)} {...htmlProps}>
      {' '}
      <LearningItemImage learningItem={learningItem} />
    </div>
  )
})
